module.exports = __webpack_public_path__ + "gt.66e9b2eefe5f6b61a229.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/gt.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/gt.svg
// module chunks = styles